<div class="wrapper default-theme" [ngClass]="getClasses()">
  <app-nav (callChatBox)="chatbox.openChatBox($event);" #navbar></app-nav>
  <main class="headerbar">
    <app-side-bar></app-side-bar>
    <div class="content-page pages container-fluid minHeight">
      <router-outlet></router-outlet>
    </div>
    <div class="overlay" (click)="toggleSidebar()"></div>
  </main>
</div>
<app-footer></app-footer>
<app-contact-us *ngIf="this.user.role==='shareholder'"></app-contact-us>
<app-chat-box (callNotify)="navbar.callNofityFn()" #chatbox></app-chat-box>


<!-- Modal -->
<div class="modal fade" #idleModal id="idleModal" tabindex="-1" role="dialog"
  aria-labelledby="idleModalTitle" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalTitle">{{"You-have-been-idle" | translate}}!</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalClose()" #closeBtn>
        </button>
      </div>
      <div class="modal-body modalBody euroFont">
        <div class="container">
          <p>{{"You-will-time-out-in" | translate}} {{countdown}} {{"seconds" | translate}}!</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn stay-button" (click)="stay();"
          translate>Stay</button>
        <button type="submit" class="btn btn-danger" (click)="logout();"
          >{{"Logout" | translate}}!</button>
      </div>
    </div>
  </div>
</div>

<button hidden='true' data-toggle="modal" data-target="#idleModal" data-keyboard="false"
data-backdrop="static" #myModalBtn>idle open</button>
